import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import actions from '../../../store/actions';
import { LayoutContext } from '../../../contexts/layout.context';

import Head from '../../../components/Head/Head';
import PhoneForm from '../../../components/Profile/Edit/PhoneForm/PhoneForm';

const EditPhone = () => {
  const { setLayout } = useContext(LayoutContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'Зміна | New Brain';
    setLayout({ page: 'Зміна' });
  }, [setLayout]);

  const goBack = () => {
    navigate('/profile');
    dispatch(actions.profile.profileError({}));
  };

  return (
    <div className="profile container">
      <Head textHead='Зміна номера телефону' goBack={goBack} />
      <div className="profile__content">
        <PhoneForm />
      </div>
    </div>
  );
};

export default EditPhone;